import { cn } from "@/lib/utils";

interface PhoneMockupProps {
  children: React.ReactNode;
  className?: string;
}

export const PhoneMockup = ({ children, className }: PhoneMockupProps) => {
  return (
    <div className={cn("relative", className)}>
      {/* Phone frame */}
      <div className="relative bg-gradient-to-b from-gray-800 to-gray-900 rounded-[2.5rem] p-2 shadow-2xl">
        {/* Inner bezel */}
        <div className="relative bg-black rounded-[2rem] overflow-hidden">
          {/* Notch */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/3 h-6 bg-black rounded-b-xl z-10" />
          
          {/* Screen content */}
          <div className="relative aspect-[9/16] overflow-hidden bg-gray-900 min-h-[400px]">
            {children}
          </div>
          
          {/* Home indicator */}
          <div className="absolute bottom-2 left-1/2 -translate-x-1/2 w-1/3 h-1 bg-white/30 rounded-full" />
        </div>
      </div>
      
      {/* Side buttons (optional visual detail) */}
      <div className="absolute right-[-3px] top-24 w-1 h-8 bg-gray-700 rounded-l-sm" />
      <div className="absolute left-[-3px] top-20 w-1 h-6 bg-gray-700 rounded-r-sm" />
      <div className="absolute left-[-3px] top-32 w-1 h-12 bg-gray-700 rounded-r-sm" />
    </div>
  );
};
